<template>
  <!--  -->
  <div class="w-full h-full p-4  bg-white rounded-lg border shadow-custom box-3">
    <!--  -->
    <loading :active.sync="loading" :is-full-page="fullPage"></loading>
    <!--  -->

    <!--  -->
    <div class="w-full h-full flex flex-col justify-between gap-4">
      <!--  -->
      <div class="flex items-center justify-end" v-if="filter">
        <!--  -->
        <div class="flex relative">
          <!--  -->
          <div class="w-full h-10 flex gap-1 transition-all duration-500 relative rounded p-1">
            <!--  -->
            <button class="rounded-md border-2 text-xs hover:bg-orange-100 px-2 py-1" :name="action" :class="timeserchtype == 'all' ? 'border-orange-500' : 'text-gray-600  border-gray-600'" value="all" @click="ChangeTypeDateRevenu($event); timeserchtype = 'all'; fromDate= null; toDate= null; timeserchproductselect= null; timeserchsellerselect= ''" >All</button> 
            <!--  -->
  
            <!--  -->
            <button class="rounded-md border-2 hover:bg-orange-100 border-orange-50 px-2 py-1" :name="action" :class="timeserchtype == 'betweendate' ? 'border-orange-500' : 'text-gray-600 border-gray-600'" value="betweendate"   @click="ChangeTypeDateRevenu($event); timeserchtype = 'betweendate';" >
              <!--  -->
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
              </svg>
              <!--  -->
            </button>
            <!--  -->
          </div>
          <!--  -->
  
          <!--  -->
          <div v-if="timeserchtype == 'betweendate'" class="absolute z-10 rounded-lg right-0 bg-white date-container">
            <!--  -->
            <div class="inline-block mt-2 w-2/5 pr-1">
              <!--  -->
              <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <!--  -->
                    <label for="date" class="bg-white text-gray-700 px-1">From 
                      <span class="text-orange-500">*</span>
                    </label>
                    <!--  -->
                  </p>
                  <!--  -->
                </div>
                <!--  -->
                <p>
                  <input :name="action" v-model="fromDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="from" type="date"/>
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
  
            <!--  -->
            <div class="inline-block mt-2 w-2/5 pr-1">
              <!--  -->
              <div class="border hover:border-orange-400 w-full focus-within:border-orange-500 focus-within:text-orange-500 transition-all duration-500 relative rounded p-1">
                <!--  -->
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                  <!--  -->
                  <p>
                    <label for="date" class="bg-white text-gray-700 px-1">To 
                      <span class="text-orange-500">*</span>
                    </label>
                  </p>
                    <!--  -->
                </div>
                <!--  -->
                <p>
                  <input :name="action" v-model="toDate" class="w-full px-1 py-1 text-gray-700 bg-gray-200 rounded" id="to" type="date"/>
                </p>
                <!--  -->
              </div>
              <!--  -->
            </div>
            <!--  -->
  
            <!--  -->
            <div class="inline-block mt-2 w-1/5 pr-1">
              <button @click="FindRecords()" :disabled="fromDate == null || toDate == null" class="w-full px-2 py-2 text-white font-light tracking-wider bg-gray-900 rounded">
                Find
              </button>
            </div>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <div class="w-full h-full flex items-center justify-center flex-wrap gap-4">
        <!--  -->
        <div class="relative" v-if="statIconName">
          <div class="text-white p-3 text-center inline-flex items-center justify-center w-16 h-16 rounded-lg" :class="[statIconColor]">
            <i class="material-icons" :class="[statPercentColor]">{{ statIconName }}</i>
          </div>
        </div>
        <!--  -->

        <!--  -->
        <div class="relative flex flex-col gap-1" v-if="statSubtitle || statTitle || rate">
          <!--  -->
          <h5 class="text-gray-700 font-normal text-md" v-if="statSubtitle">
            {{ statSubtitle }}
            <span v-if="count">: {{ count }}
              <span class="font-semibold text-lg">({{ countText }})</span>
            </span>
          </h5>
          <!--  -->

          <!--  -->
          <span class="flex items-center font-semibold text-2xl" :class="[statPercentColor]" v-if="statTitle">
            {{ statTitle }}
            <sup class="text-sm" v-if="currency">{{ currencyW }}</sup>
          </span>
          <!--  -->

          <!--  -->
          <div v-if="rate" class="flex items-center mb-2 mt-2">
            <!--  -->
            <span class="inline-flex bg-primary-200 rounded-full mr-2 p-1">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="icon fill-current text-primary-600 h-4 w-4">
                <path d="M20 22H4a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2h4V8c0-1.1.9-2 2-2h4V4c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM14 8h-4v12h4V8zm-6 4H4v8h4v-8zm8-8v16h4V4h-4z" class="heroicon-ui"></path>
              </svg>
            </span>
            <!--  -->

            <!--  -->
            <span class="text-grey-darker">{{titleRate}} {{rate}} %</span>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->

      <!--  -->
      <p v-if="!filter && statPercent && statDescripiron" class="text-sm text-gray-500 mt-4">
        <!--  -->
        <span class="mr-2" :class="[statPercentColor]">
          <i :class="[ statArrow === 'up' ? `fas fa-arrow-up` : `fas fa-arrow-down`]"></i>
          {{ statPercent }}
        </span>
        <!--  -->

        <!--  -->
        <span class="whitespace-no-wrap">{{ statDescripiron }}</span>
        <!--  -->
      </p>
      <!--  -->

      <!--  -->
      <div class="flex flex-col gap-4" v-if="filter && (sellers || products)">
        <!--  -->
        <div v-if="userType && userType != 'Seller'" class="relative w-full max-w-full flex-grow flex-1">
          <!--  -->
          <div class="border h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
            <!--  -->
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="category" class="bg-white text-gray-700 px-1">{{ $t('seller') }} :
                  <span :class="$colors.required">*</span>
                </label>
              </p>
            </div>
            <!--  -->

            <!--  -->
            <p>
              <v-select v-model="timeserchsellerselect" :options="sellers" label="company" placeholder="Seller ..." @input="ChangeSeller($event, 'Seller')" ></v-select>
            </p>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->

        <!--  -->
        <div v-if="products" class="relative w-full max-w-full flex-grow flex-1">
          <!--  -->
          <div class="border h-10 hover:border-orange-500  focus-within:border-orange-500 focus-within:text-primary-500  transition-all duration-500 relative rounded p-1">
            <!--  -->
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="product" class="bg-white text-gray-700 px-1">{{ $t('product') }} :
                  <span :class="$colors.required">*</span>
                </label>
              </p>
            </div>
            <!--  -->

            <!--  -->
            <p>
              <v-select v-model="timeserchproductselect" :options="products" label="name" :disabled="!timeserchsellerselect" @input="ChangeSeller($event, 'product')" @search="getProducts($event, 'storeino')" placeholder="Product name"></v-select>
            </p>
            <!--  -->
          </div>
          <!--  -->
        </div>
        <!--  -->
      </div>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
  export default {
    name: 'card-stats',
    props: {
      statSubtitle: {
        default: 'Traffic',
      },
      loading: { required: false },
      timeserch: {},
      userType: { default: null },
      timeserchseller: {},
      titleRate: {},
      from: {},
      to: {},
      filter: {
        default: false,
      },
      statTitle: {},
      action: {},
      statArrow: {
        default: 'up',
        validator: function(value) {
          // The value must match one of these strings
          return ['up', 'down'].indexOf(value) !== -1;
        },
      },
      statPercent: {},
      // can be any of the text color utilities
      // from tailwindcss
      statPercentColor: {
        default: 'text-primary-500',
      },
      statDescripiron: {},
      currency: { default: false },
      count: { type: Number, default: 0 },
      sellers: { default: null },
      products: { default: null },
      countText: {},
      rate: {},
      statIconName: {
        default: 'far fa-chart-bar',
      },
      // can be any of the background color utilities
      // from tailwindcss
      statIconColor: {
        type: String,
        default: 'bg-red-500',
      },
    },
    data() {
      return {
        timeserchtype: this.timeserch,
        fromDate: this.from,
        toDate: this.to,
        timeserchsellerselect: this.timeserchseller,
        timeserchproductselect: this.timeserchproduct,
        fullPage: false,
        filerButton:false,
        currencyW: '',
        currentUser: null,
      };
    },
    async mounted() {
      await this.getCurrency();
      await this.getUser();

      if (this.currentUser && this.currentUser.type == 'Seller') {
      this.timeserchsellerselect = this.currentUser;
    }
    },
    computed: {
      warhouseSelected() {
        return this.$store.getters['wharhouse/warhouseSelected'];
      },
    },
    watch: {
      warhouseSelected: async function(oldVal, newVal) {
        await this.getCurrency();
        
      },
      timeserch: function() {
        this.timeserchtype = this.timeserch;
      },
    },
    methods: {
      async getUser() {
          const res = await this.$server.me('users');
          if (res.content) this.currentUser = res.content;
          else this.currentUser = {};
      },
      async getCurrency() {
        await this.$store.dispatch('wharhouse/getCurrency').then(res => {
          this.currencyW = res;
        });
      },
      ChangeTypeDateRevenu: function(val) {
        console.log('check val',val.target.value);
        console.log('check name',val.target.name);
        this.$emit('ChangeTypeDateRevenu', val);
      },
      FindRecords: function() {
        this.$emit('FindRecords', this.action, this.fromDate, this.toDate);
      },
      ChangeSeller: function (event, action) {
      this.$emit('ChangeSeller', event, action);
    },
      getProducts: function(name) {
      this.$emit('getProducts', name);
    }
    },
  };
</script>

<style scoped>
  .text-grey-darker {
    color: #596a73;
    font-weight: 600;
  }
  .date-container{
    width: max-content;
    top: 47px;
  }
</style>
